import { Component } from '@angular/core';
import { BarcodeScannerService } from "../../services/barcode-scanner.service";

@Component({
  selector: 'html5-qrcode',
  templateUrl: './html5-qrcode.html'
})
export class Html5QrcodeComponent {

  constructor(
    public barcodeScanner: BarcodeScannerService
  ) {}

}




// WEBPACK FOOTER //
// ./src/components/html5-qrcode/html5-qrcode.ts